<template>
    <button class="flex size-full touch-manipulation items-center justify-center rounded-3xl bg-primary px-6 py-16 text-4xl font-bold text-white xl:p-20 xl:text-4xl">
        <ion-icon :icon="icon" class="mr-3" />
        <slot></slot>
    </button>
</template>

<script lang="ts" setup>
    import { IonIcon } from "@ionic/vue";

    defineProps<{
        icon: string;
    }>();
</script>
